// extracted by mini-css-extract-plugin
module.exports = {"container":"sub_container__x7dMg","content":"sub_content__YPfJO","italic":"sub_italic__PHput","textCenter":"sub_textCenter__FT_LI"};